import { render, staticRenderFns } from "./ServicePointTabs.vue?vue&type=template&id=43931e06&"
import script from "./ServicePointTabs.vue?vue&type=script&lang=ts&"
export * from "./ServicePointTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointTabs.vue?vue&type=style&index=0&id=43931e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports